var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 48,
    viewBox: "0 0 137 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 513003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LAHJA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46 19.4618V7H50.2321V16.2039H55.8989V19.4618H46Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M62.6049 19.4618L68.0923 7H72.2527L77.7402 19.4618H73.3646L69.3118 8.99389H70.9616L66.9088 19.4618H62.6049ZM65.8687 17.2899L66.9446 14.2635H72.719L73.7949 17.2899H65.8687Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M93.2819 7H97.5141V19.4618H93.2819V7ZM89.3726 19.4618H85.1405V7H89.3726V19.4618ZM93.5689 14.8688H89.0857V11.4151H93.5689V14.8688Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M109.452 19.7467C108.472 19.7467 107.587 19.5924 106.798 19.2838C106.009 18.9634 105.352 18.5005 104.826 17.8952L107.103 15.2248C107.438 15.6283 107.767 15.9369 108.089 16.1505C108.412 16.3523 108.747 16.4532 109.094 16.4532C110.002 16.4532 110.456 15.9369 110.456 14.9044V10.1689H106.188V7H114.635V14.6551C114.635 16.3642 114.192 17.64 113.308 18.4827C112.423 19.3253 111.138 19.7467 109.452 19.7467Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M121.675 19.4618L127.162 7H131.323L136.81 19.4618H132.434L128.382 8.99389H130.031L125.979 19.4618H121.675ZM124.938 17.2899L126.014 14.2635H131.789L132.865 17.2899H124.938Z",
    fill: "#4254EA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "KAMU"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M62.1127 39.0449L61.8795 34.434L66.6138 29.2534H71.2225L65.9144 35.0571L63.5652 37.4426L62.1127 39.0449ZM58.3288 41.7152V29.2534H62.4892V41.7152H58.3288ZM66.5779 41.7152L62.8838 36.8729L65.6275 33.9889L71.4736 41.7152H66.5779Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M76.7726 41.7152L82.2601 29.2534H86.4205L91.9079 41.7152H87.5323L83.4795 31.2473H85.1293L81.0765 41.7152H76.7726ZM80.0364 39.5433L81.1124 36.5169H86.8867L87.9627 39.5433H80.0364Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M99.3081 41.7152V29.2534H102.787L107.808 37.3892H105.979L110.857 29.2534H114.336L114.372 41.7152H110.516L110.48 35.0215H111.09L107.754 40.5937H105.889L102.411 35.0215H103.164V41.7152H99.3081Z",
    fill: "#4254EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M129.15 42.0001C127.225 42.0001 125.725 41.4838 124.649 40.4513C123.573 39.4187 123.035 37.9708 123.035 36.1074V29.2534H127.267V35.9828C127.267 36.9323 127.44 37.6088 127.787 38.0123C128.134 38.404 128.6 38.5998 129.186 38.5998C129.784 38.5998 130.25 38.404 130.585 38.0123C130.931 37.6088 131.105 36.9323 131.105 35.9828V29.2534H135.265V36.1074C135.265 37.9708 134.727 39.4187 133.651 40.4513C132.575 41.4838 131.075 42.0001 129.15 42.0001Z",
    fill: "#4254EA"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 512998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M18.3425 34.8194V17.3388C18.3429 15.0619 17.8689 12.8073 16.9473 10.7037C16.0257 8.60016 14.6747 6.68871 12.9714 5.07862C11.2681 3.46852 9.2459 2.1913 7.02022 1.3199C4.79456 0.448503 2.40908 0 0 0V29.2774C0 33.8753 1.9324 38.2849 5.37217 41.5365C8.81196 44.788 13.4774 46.6152 18.3425 46.6161V34.8194Z",
    fill: "url(#paint0_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2_2",
    d: "M23.6429 30.6612H15.718C11.9161 30.1609 8.36901 28.5679 5.55739 26.0982C2.74576 23.6285 0.80565 20.4014 0 16.8546V30.6612C0 35.2591 1.9324 39.6688 5.37217 42.9203C8.81196 46.1719 13.4774 47.9991 18.3425 48H42C42.0004 45.722 41.5259 43.4663 40.6034 41.3617C39.6809 39.2573 38.3285 37.3452 36.6237 35.7349C34.9189 34.1246 32.8949 32.8478 30.6676 31.9771C28.4402 31.1065 26.0532 30.6594 23.6429 30.6612Z",
    fill: "url(#paint1_linear_1_2)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 22.4093,
    y1: 0.0968608,
    x2: 7.85667,
    y2: 28.6635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6DFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#90D4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744792,
    stopColor: "#76CEF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AC8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2",
    x1: 32.75,
    y1: 26.3611,
    x2: 7.71588,
    y2: 40.8287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0666667,
    stopColor: "#5BC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133333,
    stopColor: "#5DC9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#60CAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266667,
    stopColor: "#65CBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#6BCCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#72CEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#7BD1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533333,
    stopColor: "#83D3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8BD5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#93D7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733333,
    stopColor: "#99D8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9EDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866667,
    stopColor: "#A1DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933333,
    stopColor: "#A3DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4DBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c4986d1ea6357702a79b67e4969ab8d1.svg";
export { ForwardRef as ReactComponent };